(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kima-visual-bundle-hombre"]) return;
  try {
    
(() => {
  const dataNode = document.getElementById('kima-vbh-data');
  if (!dataNode || window.__kimaVisualBundleHombre) return;
  const data = JSON.parse(dataNode.textContent);
  window.__kimaVisualBundleHombre = true;
  const t = data.labels;
  const isClassic = false;
  const normalize = v => String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
  const colors = [
    {names:['Negro','Black','Preto','Nero','ブラック'],hex:'#111214',match:'variant-only-black'},
    {names:['Azul Marino','Navy Blue','Azul-marinho','Blu navy','ネイビー'],hex:'#17264d',match:'variant-only-navy'},
    {names:['Blanco','White','Branco','Bianco','ホワイト'],hex:'#ffffff',match:'variant-only-white'},
    {names:['Burdeos','Bordeaux','Burgundy','ボルドー'],hex:'#941936',match:'soft-burdeos'},
    {names:['Rosa','Rose','Pink','ピンク'],hex:'#eba0b2',match:'soft-rosa'},
    {names:['Gris Claro','Light Grey','Light Gray','Cinza Claro','Grigio chiaro','ライトグレー'],hex:'#b9bdc3',match:'variant-only-light-gray'},
    {names:['Marrón Claro','Light Brown','Marrom-claro','Marrone chiaro','ライトブラウン'],hex:'#c8946b',match:'soft-marron-claro'},
    {names:['Flowers Blanco','White Flowers','Blanco Flowers','Flores Brancas','Fiori bianchi','フラワー（ホワイト）'],match:'soft-flowers-blanco',texture:'kima-swatch-flowers-blanco.webp'},
    {names:['Flowers Gris','Gray Flowers','Grey Flowers','Flores Cinzas','Fiori grigi','フラワー（グレー）'],match:'soft-flowers-gris',texture:'kima-swatch-flowers-gris.webp'},
    {names:['Flowers Azul Marino','Navy Blue Flowers','Navy Flowers','Flores Azul-Marinho','Fiori blu navy','フラワー（ネイビー）'],match:'soft-flowers-azul',texture:'kima-swatch-flowers-azul.webp'},
    {names:['Flowers Rosa','Rose Flowers','Pink Flowers','Roses','Flowers Rose','Flowers Pink','Flores Rosa','Fiori rosa','フラワー（ピンク）'],match:'soft-flowers-rosa',texture:'kima-swatch-flowers-rosa.webp'}
  ];
  const colorInfo = value => colors.find(c=>c.names.some(n=>normalize(n)===normalize(value)));
  const galleryKeys={'variant-only-black':'negro','variant-only-navy':'azul-marino','variant-only-white':'blanco','soft-burdeos':'burdeos','soft-rosa':'rosa','variant-only-light-gray':'gris-claro','soft-marron-claro':'marron-claro','soft-flowers-blanco':'flowers-blanco','soft-flowers-gris':'flowers-gris','soft-flowers-azul':'flowers-azul','soft-flowers-rosa':'flowers-rosa'};
  const sizeGuide = data.images.find(img=>img.src.includes('kima-hombre-06-guide-tailles')) || data.images.find(img=>img.src.includes('06-guide-tailles'));
  const galleryFor = value => {
    const images=(data.testGalleries[galleryKeys[colorInfo(value)?.match]] || []).map((src,i)=>({src,alt:`KIMA — ${value} — ${i+1}`}));
    if(sizeGuide)images.splice(1,0,{src:sizeGuide.src,alt:data.locale.startsWith('en')?'KIMA — Size guide':'KIMA — Guía de tallas'});
    return images;
  };
  const imageFor = value => galleryFor(value)[0] || data.images.find(i=>colorInfo(value) && i.src.includes(colorInfo(value).match));
  const displayWidth=window.matchMedia('(max-width:749px)').matches?640:960;
  const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sized=(src,width)=>{const url=new URL(src,location.href);url.searchParams.set('width',width);return url.href;};
  const readyImages=new Map();
  const prepare=(src,priority='low')=>{
    if(readyImages.has(src))return readyImages.get(src);
    const img=new Image();img.decoding='async';img.fetchPriority=priority;
    const pending=new Promise(resolve=>{img.onload=()=>{img.decode().catch(()=>{}).then(()=>resolve(img));};img.onerror=()=>{readyImages.delete(src);resolve(null);};});
    readyImages.set(src,pending);img.src=src;return pending;
  };
  const warmColor=value=>{const photo=imageFor(value);if(photo)prepare(sized(photo.src,displayWidth),'high');};
  const warmColors=async()=>{
    if(navigator.connection?.saveData)return;
    const queue=Object.values(data.testGalleries).map(items=>items[0]).filter(Boolean);
    await Promise.all(Array.from({length:2},async()=>{while(queue.length)await prepare(sized(queue.shift(),displayWidth));}));
  };
  let galleryRequest=0;
  const el = (tag,cls,text) => { const e=document.createElement(tag); if(cls)e.className=cls; if(text!==undefined)e.textContent=text; return e; };
  const button = (cls,text) => {const e=el('button',cls,text);e.type='button';return e;};
  const rows = bar => Array.from(bar.querySelectorAll('.kvbp-bar-variant-selector-wrapper')).filter(w=>w.querySelector('select[data-name="Color"]'));
  const selects = row => Array.from(row.querySelectorAll('select.kvbp-bar-variant-select'));
  const pause = () => new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
  const money = cents => new Intl.NumberFormat(data.locale,{style:'currency',currency:data.currency}).format(cents/100);
  let selectedOffer=1;
  const offers=[{id:'',count:1,paid:1,title:t.single},{id:'',count:4,paid:2,title:t.double},{id:'',count:8,paid:3,title:t.five}];
  let nativeEngine, nativeBars, bundleRoot, syncVersion=0, syncPending=Promise.resolve(), submitReady=false;
  function choose(row,optionIndex,value) {
    const source=selects(row);source[optionIndex].value=value;
    const options=source.map(s=>s.value);
    const available=data.variants.filter(v=>v.available&&v.options[0]===options[0]);
    if(!available.some(v=>v.options[1]===options[1])&&available.length)source[1].value=available[0].options[1];
    source[1].querySelectorAll('option').forEach(o=>{o.disabled=!available.some(v=>v.options[1]===o.value);});
    const bar=row.closest('.kvbp-bar');const list=rows(bar);enhance(row,list.indexOf(row),list.length);
    showGallery(source[0].value);
    queueSync();
  }
  function showGallery(value) {
    const photo=imageFor(value),original=document.querySelector('product-info media-gallery');
    if(!photo||!original)return;
    const parent=original.parentElement;
    let gallery=parent.querySelector('.kvb-gallery');
    if(gallery?.dataset.color===value)return;
    if(!gallery){gallery=el('div','kvb-gallery');original.before(gallery);}
    gallery.dataset.color=value;
    const request=++galleryRequest;
    const items=galleryFor(value);if(!items.length)items.push(photo);
    const sources=items.map(item=>sized(item.src,displayWidth));
    const track=el('div','kvb-track'),thumbs=el('div','kvb-thumbs');
    const slides=items.map((item,i)=>{
      const img=el('img');img.width=1254;img.height=1254;img.decoding='async';img.alt=item.alt;img.draggable=false;
      if(i===0)img.src=sources[0];else{img.fetchPriority='low';if(navigator.connection?.saveData){img.loading='lazy';img.src=sources[i];}}
      track.append(img);return img;
    });
    let activeIndex=0,frame=0,gesture=null;
    const selectImage=index=>{
      const target=(index+items.length)%items.length;
      track.scrollTo({left:target*track.clientWidth,behavior:reducedMotion?'auto':'smooth'});
    };
    // Fingers scroll the track natively; the scroll position drives the active thumbnail.
    track.addEventListener('scroll',()=>{
      if(frame)return;
      frame=requestAnimationFrame(()=>{
        frame=0;if(!track.clientWidth)return;
        const index=Math.max(0,Math.min(items.length-1,Math.round(track.scrollLeft/track.clientWidth)));
        if(index===activeIndex)return;
        activeIndex=index;thumbs.querySelectorAll('button').forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));
      });
    },{passive:true});
    // A mouse cannot pan a scroller, so desktop keeps the drag-to-change gesture.
    track.onpointerdown=event=>{
      if(event.pointerType!=='mouse'||!event.isPrimary||event.button!==0){gesture=null;return;}
      gesture={id:event.pointerId,x:event.clientX,y:event.clientY};
      track.setPointerCapture(event.pointerId);
    };
    track.onpointercancel=()=>{gesture=null;};
    track.onpointerup=event=>{
      const start=gesture;gesture=null;
      if(!start||start.id!==event.pointerId)return;
      const dx=event.clientX-start.x,dy=event.clientY-start.y;
      if(Math.abs(dx)>=40&&Math.abs(dx)>Math.abs(dy)*1.5)selectImage(activeIndex+(dx<0?1:-1));
    };
    items.forEach((item,i)=>{
      const b=button('');b.setAttribute('aria-label',item.alt);b.setAttribute('aria-pressed',String(i===0));
      const img=el('img');img.src=sized(item.src,128);img.alt='';img.width=64;img.height=64;img.decoding='async';b.append(img);
      b.addEventListener('click',()=>selectImage(i));thumbs.append(b);
    });
    // On a colour change the previous photos stay up until the new first photo is ready (no grey flash).
    const mount=()=>{
      if(request!==galleryRequest)return;
      const oldTrack=gallery.querySelector('.kvb-track'),oldThumbs=gallery.querySelector('.kvb-thumbs');
      if(oldTrack)oldTrack.replaceWith(track);else gallery.prepend(track);
      if(oldThumbs)oldThumbs.replaceWith(thumbs);else gallery.append(thumbs);
    };
    const ready=prepare(sources[0],'high');
    if(gallery.querySelector('.kvb-track'))ready.then(mount);else mount();
    // The other photos wait for the first one, unless the shopper starts scrolling before it is in.
    const fill=()=>slides.forEach((img,i)=>{if(!img.getAttribute('src'))img.src=sources[i];});
    ready.then(()=>{if(request===galleryRequest)fill();});
    track.addEventListener('scroll',fill,{passive:true,once:true});
    parent.classList.add('kvb-gallery-active');
  }
  function zoom(value) {
    const image=imageFor(value);if(!image)return;
    const dialog=el('dialog','kvb-dialog');const close=button('',t.close);const img=el('img');img.src=image.src;img.alt=`KIMA — ${value}`;
    dialog.append(close,img);document.body.append(dialog);close.onclick=()=>dialog.close();dialog.addEventListener('close',()=>dialog.remove());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});dialog.showModal();
  }
  function enhance(row,index,total) {
    const source=selects(row);if(source.length!==2)return;
    let card=row.querySelector('.kvb-card');
    if(!card){
      card=el('div','kvb-card');card.dataset.collapsed='false';
      card.addEventListener('click',event=>{event.stopPropagation();});
      const heading=el('div','kvb-heading'),title=el('p','kvb-title'),toggle=button('kvb-toggle',t.close);
      toggle.setAttribute('aria-expanded','true');toggle.onclick=()=>{const collapsed=card.dataset.collapsed==='false';card.dataset.collapsed=String(collapsed);toggle.textContent=collapsed?t.edit:t.close;toggle.setAttribute('aria-expanded',String(!collapsed));};
      heading.append(title,toggle);
      const body=el('div','kvb-body'),visuals=el('div','kvb-visuals'),photo=button('kvb-photo'),img=el('img'),zoomIcon=el('span','kvb-zoom','⌕');zoomIcon.setAttribute('aria-hidden','true');photo.setAttribute('aria-label',t.zoom);photo.append(img,zoomIcon);photo.onclick=()=>zoom(selects(row)[0].value);
      const swatches=el('div','kvb-swatches');swatches.setAttribute('role','group');swatches.setAttribute('aria-label',t.color);
      Array.from(source[0].options).forEach((o,i)=>{const b=button('kvb-swatch');b.dataset.value=o.value;b.title=o.textContent;b.setAttribute('aria-label',o.textContent);const c=colorInfo(o.value);if(c?.hex)b.style.setProperty('--swatch',c.hex);if(c?.texture)b.style.setProperty('--texture',`url('/cdn/shop/files/${c.texture}')`);b.addEventListener('pointerenter',()=>warmColor(o.value),{passive:true});b.addEventListener('touchstart',()=>warmColor(o.value),{passive:true});b.addEventListener('focus',()=>warmColor(o.value));b.onclick=()=>choose(row,0,o.value);swatches.append(b);});
      const sizes=el('div','kvb-sizes');sizes.setAttribute('role','group');sizes.setAttribute('aria-label',t.size);
      const order=['S','M','L/XL','2XL','3XL'];Array.from(source[1].options).sort((a,b)=>order.indexOf(a.value)-order.indexOf(b.value)).forEach(o=>{const b=button('kvb-size',o.textContent);b.dataset.value=o.value;b.onclick=()=>choose(row,1,o.value);sizes.append(b);});
      visuals.append(photo,swatches);body.append(visuals,sizes);card.append(heading,body);row.append(card);row.classList.add('kvb-native');
    }
    const color=source[0].value,size=source[1].value,photo=imageFor(color);
    const title=card.querySelector('.kvb-title');const text=`${total>1?`#${index+1}: `:''}${color} - ${size}`;
    if(title.dataset.label!==text){title.dataset.label=text;title.textContent=text;if(index>=(offers.find(offer=>offer.count===total)?.paid??total))title.append(el('span','kvb-free',t.free));}
    const img=card.querySelector('.kvb-photo img');if(photo&&img.getAttribute('src')!==sized(photo.src,displayWidth)){img.src=sized(photo.src,displayWidth);img.alt=`KIMA — ${color}`;img.width=232;img.height=232;}
    [0,1].forEach(n=>card.querySelectorAll(n===0?'.kvb-swatch':'.kvb-size').forEach(b=>{const option=Array.from(source[n].options).find(o=>o.value===b.dataset.value);const selected=source[n].value===b.dataset.value;if(b.getAttribute('aria-pressed')!==String(selected))b.setAttribute('aria-pressed',String(selected));const disabled=!option||option.disabled;if(b.disabled!==disabled)b.disabled=disabled;}));
  }
  function refreshPrices(){
    if(!bundleRoot||!nativeBars)return;
    offers.forEach((offer,index)=>{
      const native=nativeBars.querySelector(`[data-deal-bar-id="${offer.id}"]`),bar=bundleRoot.querySelectorAll('.kvbp-bar')[index];
      if(!native||!bar)return;
      const price=native.querySelector('.kaching-bundles__bar-price')?.textContent.trim();
      let full=native.querySelector('.kaching-bundles__bar-full-price')?.textContent.trim();
      if(price)bar.querySelector('.kvbp-bar-price').textContent=price;
      if(offer.count===1 && !isClassic && !full){
        const variant=selectedOffer===0?selectedVariants()[0]:data.variants.find(v=>v.available&&/^(Negro|Black|Noir|Preto|Nero|ブラック)$/i.test(v.options[0]));
        if(variant){const step=data.currency==='CLP'?100:1;const reference=variant.compare_at_price>variant.price?variant.compare_at_price:Math.round(variant.price*2995/2595/step)*step;full=money(reference);}
      }
      const crossed=bar.querySelector('.kvbp-bar-full-price');if(crossed){crossed.textContent=full||'';crossed.hidden=!full;}
      const subtitle=native.querySelector('.kaching-bundles__bar-subtitle')?.textContent.trim();
      bar.querySelector('.kvbp-bar-subtitle').textContent=offer.count===1?t.single_subtitle:(subtitle||'');
    });
  }
  function selectedVariants(){
    const bar=bundleRoot.querySelectorAll('.kvbp-bar')[selectedOffer];
    return rows(bar).map(row=>{const options=selects(row).map(s=>s.value);return data.variants.find(v=>v.available&&v.options.every((o,i)=>o===options[i]));});
  }
  function queueSync(){
    const version=++syncVersion;
    syncPending=syncPending.catch(()=>{}).then(async()=>{
      if(version!==syncVersion)return;
      const offer=offers[selectedOffer],variants=selectedVariants();
      if(variants.some(v=>!v))throw new Error(t.unavailable);
      nativeEngine.selectedDealBarId=offer.id;
      await pause();
      for(let i=0;i<variants.length;i++){
        for(let n=0;n<2;n++){
          if(version!==syncVersion)return;
          const nativeBar=nativeBars.querySelector(`[data-deal-bar-id="${offer.id}"]`);
          const inputs=nativeBar?.querySelectorAll('select.kaching-bundles__bar-variant-select');
          const input=inputs?.[i*2+n];
          if(!input)throw new Error(t.unavailable);
          if(input.value!==variants[i].options[n]){input.value=variants[i].options[n];input.dispatchEvent(new Event('change',{bubbles:true}));await pause();}
        }
      }
      await pause();refreshPrices();
    });
    return syncPending;
  }
  function verifyNativeItems(){
    const items=nativeEngine.items().filter(item=>{try{return !JSON.parse(item.properties?.__kaching_bundles||'{}').gift;}catch{return true;}});
    const wanted=new Map();for(const v of selectedVariants()){if(!v)throw new Error(t.unavailable);wanted.set(Number(v.id),(wanted.get(Number(v.id))||0)+1);}
    const actual=new Map();for(const item of items){actual.set(Number(item.id),(actual.get(Number(item.id))||0)+item.quantity);}
    if(wanted.size!==actual.size||[...wanted].some(([id,n])=>actual.get(id)!==n)){throw new Error(t.unavailable);}
    return items;
  }
  function setupCheckout(){
    const buttons=document.querySelector('product-info .product-form__buttons');if(!buttons)return;
    const error=el('p','kvb-checkout-error');error.setAttribute('role','alert');error.hidden=true;buttons.after(error);
    const gate=async event=>{
      const path=event.composedPath();const target=path.find(n=>n?.matches?.('button, a, shop-pay-wallet-button, shopify-accelerated-checkout'));
      if(submitReady||!target||!buttons.contains(target))return;
      if(!target.matches('.product-form__submit')){
        try{verifyNativeItems();error.hidden=true;}
        catch(e){event.preventDefault();event.stopImmediatePropagation();error.textContent=e.message||t.unavailable;error.hidden=false;}
        return;
      }
      event.preventDefault();event.stopImmediatePropagation();
      if(buttons.getAttribute('aria-busy')==='true')return;
      buttons.setAttribute('aria-busy','true');error.hidden=true;
      try{await queueSync();const items=verifyNativeItems();submitReady=true;nativeEngine.dispatchEvent(new CustomEvent('add-to-cart-requested',{detail:{items},bubbles:true}));}
      catch(e){error.textContent=e.message||t.unavailable;error.hidden=false;}
      finally{submitReady=false;buttons.removeAttribute('aria-busy');}
    };
    document.addEventListener('click',gate,true);
  }
  function mount() {
    const native=document.querySelector('product-info .kaching-bundles__bars');nativeEngine=document.querySelector('product-info kaching-bundles-block');if(!native||typeof nativeEngine?.items!=='function'||!nativeEngine.dealBlock||document.getElementById('kima-bundle-prototype'))return false;
    const marketBars=Array.from(native.querySelectorAll('.kaching-bundles__bar[data-deal-bar-id]'));
    if(marketBars.length!==offers.length)return false;
    offers.forEach((offer,index)=>{offer.id=marketBars[index].dataset.dealBarId;});
    nativeBars=native;
    const root=el('div','kima-vb');root.id='kima-bundle-prototype';bundleRoot=root;
    const unique=n=>Array.from(new Set(data.variants.map(v=>v.options[n])));
    offers.forEach((offer,offerIndex)=>{
      const bar=el('div','kvbp-bar'+(offerIndex===selectedOffer?' kvbp-bar--selected':''));
      const container=el('div','kvbp-bar-container');container.style.position='relative';
      if(offerIndex===1){const badge=el('div','kvbp-bar-most-popular');badge.append(el('div','kvbp-bar-most-popular__content',t.bestseller));container.append(badge);}
      const header=button('kvbp-bar-main');header.setAttribute('aria-expanded',String(offerIndex===selectedOffer));
      const radio=el('span','kvbp-bar-radio');radio.setAttribute('aria-hidden','true');
      const content=el('div','kvbp-bar-content'),left=el('div','kvbp-bar-content-left'),price=el('div','kvbp-bar-pricing');
      left.append(el('div','kvbp-bar-title',offer.title),el('div','kvbp-bar-subtitle',offer.count===1?t.single_subtitle:''));
      price.append(el('s','kvbp-bar-full-price',''));price.append(el('div','kvbp-bar-price','…'));content.append(left,price);header.append(radio,content);
      const variants=el('div','kvbp-bar-variants');
      for(let i=0;i<offer.count;i++){
        const row=el('div','kvbp-bar-variant-selector-wrapper'),hidden=el('div','kvbp-bar-variant');
        [0,1].forEach(n=>{const select=el('select','kvbp-bar-variant-select');select.dataset.name=n===0?'Color':'Talla';select.setAttribute('aria-label',n===0?t.color:t.size);unique(n).forEach(v=>{const o=el('option','',v);o.value=v;select.append(o);});const isDefaultColor=v=>['negro','black','noir','preto','nero',normalize('ブラック')].includes(normalize(v.options[0]));const initial=data.variants.find(v=>v.available&&isDefaultColor(v)&&v.options[1]==='M')||data.variants.find(v=>v.available&&isDefaultColor(v))||data.variants.find(v=>v.available);select.value=initial.options[n];hidden.append(select);});
        row.append(hidden);variants.append(row);
      }
      container.append(header,variants);bar.append(container);root.append(bar);
      header.onclick=()=>{selectedOffer=offerIndex;root.querySelectorAll('.kvbp-bar').forEach((b,j)=>{b.classList.toggle('kvbp-bar--selected',j===offerIndex);b.querySelector('.kvbp-bar-main').setAttribute('aria-expanded',String(j===offerIndex));});showGallery(selects(rows(bar)[0])[0].value);queueSync();};
      rows(bar).forEach((r,i)=>enhance(r,i,offer.count));
    });
    native.before(root);native.hidden=true;native.style.display='none';document.querySelector('product-info').classList.add('kvb-prototype-active');
    document.querySelectorAll('product-info *').forEach(e=>{if(e.children.length===0&&e.textContent.trim()==='COMPRA 2 Y LLÉVATE 2 GRATIS')e.textContent=t.double;});
    showGallery(selects(rows(root.querySelectorAll('.kvbp-bar')[selectedOffer])[0])[0].value);
    new MutationObserver(refreshPrices).observe(native,{childList:true,subtree:true,characterData:true});
    refreshPrices();queueSync();setupCheckout();
    setTimeout(warmColors,250);
    return true;
  }
  if(!mount()){const observer=new MutationObserver(()=>{if(mount())observer.disconnect();});observer.observe(document.body,{childList:true,subtree:true});setTimeout(()=>observer.disconnect(),30000);}

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kima-visual-bundle"]) return;
  try {
    
(() => {
  const dataNode = document.getElementById('kima-vb-data');
  if (!dataNode || window.__kimaVisualBundle) return;
  const data = JSON.parse(dataNode.textContent);
  window.__kimaVisualBundle = true;
  const t = data.labels;
  const isClassic = [15462524158063,15590718799983].includes(data.productId);
  const normalize = v => String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
  const colors = [
    {names:['Negro','Black','Preto','Nero','ブラック'],hex:'#111214',match:'variant-only-black'},
    {names:['Azul Marino','Navy Blue','Azul-marinho','Blu navy','ネイビー'],hex:'#17264d',match:'variant-only-navy'},
    {names:['Blanco','White','Branco','Bianco','ホワイト'],hex:'#ffffff',match:'variant-only-white'},
    {names:['Burdeos','Bordeaux','Burgundy','ボルドー'],hex:'#941936',match:'soft-burdeos'},
    {names:['Rosa','Rose','Pink','ピンク'],hex:'#eba0b2',match:'soft-rosa'},
    {names:['Gris Claro','Light Grey','Light Gray','Cinza Claro','Grigio chiaro','ライトグレー'],hex:'#b9bdc3',match:'variant-only-light-gray'},
    {names:['Marrón Claro','Light Brown','Marrom-claro','Marrone chiaro','ライトブラウン'],hex:'#c8946b',match:'soft-marron-claro'},
    {names:['Flowers Blanco','White Flowers','Blanco Flowers','Flores Brancas','Fiori bianchi','フラワー（ホワイト）'],match:'soft-flowers-blanco',texture:'kima-swatch-flowers-blanco.webp'},
    {names:['Flowers Gris','Gray Flowers','Grey Flowers','Flores Cinzas','Fiori grigi','フラワー（グレー）'],match:'soft-flowers-azul',texture:'kima-swatch-flowers-azul.webp'},
    {names:['Flowers Azul Marino','Navy Blue Flowers','Navy Flowers','Flores Azul-Marinho','Fiori blu navy','フラワー（ネイビー）'],match:'soft-flowers-gris',texture:'kima-swatch-flowers-gris.webp'},
    {names:['Flowers Rosa','Rose Flowers','Pink Flowers','Roses','Flowers Rose','Flowers Pink','Flores Rosa','Fiori rosa','フラワー（ピンク）'],match:'soft-flowers-rosa',texture:'kima-swatch-flowers-rosa.webp'}
  ];
  const colorInfo = value => colors.find(c=>c.names.some(n=>normalize(n)===normalize(value)));
  const galleryKeys={'variant-only-black':'negro','variant-only-navy':'azul-marino','variant-only-white':'blanco','soft-burdeos':'burdeos','soft-rosa':'rosa','variant-only-light-gray':'gris-claro','soft-marron-claro':'marron-claro','soft-flowers-blanco':'flowers-blanco','soft-flowers-gris':'flowers-gris','soft-flowers-azul':'flowers-azul','soft-flowers-rosa':'flowers-rosa'};
  const sizeGuide = data.images.find(img=>img.src.includes('06-guide-tailles'));
  const galleryFor = value => {
    const images=(data.testGalleries[galleryKeys[colorInfo(value)?.match]] || []).map((src,i)=>({src,alt:`KIMA — ${value} — ${i+1}`}));
    if(sizeGuide)images.splice(1,0,{src:sizeGuide.src,alt:data.locale.startsWith('en')?'KIMA — Size guide':'KIMA — Guía de tallas'});
    return images;
  };
  const imageFor = value => { const classicPhoto = isClassic && {"negro":"https://cdn.shopify.com/s/files/1/0749/3838/4495/files/kima-test-negro-01-original.webp?v=1789463604","azul-marino":"https://cdn.shopify.com/s/files/1/0749/3838/4495/files/kima-test-azul-marino-01-original.webp?v=1789463645","blanco":"https://cdn.shopify.com/s/files/1/0749/3838/4495/files/kima-test-blanco-01-original.webp?v=1789463681","gris-claro":"https://cdn.shopify.com/s/files/1/0749/3838/4495/files/kima-test-gris-claro-01-original.webp?v=1789463800"}[galleryKeys[colorInfo(value)?.match]]; return (classicPhoto ? {src:classicPhoto,alt:`KIMA — ${value}`} : null) || (isClassic ? null : galleryFor(value)[0]) || data.images.find(i=>colorInfo(value) && i.src.includes(colorInfo(value).match)); };
  const displayWidth=window.matchMedia('(max-width:749px)').matches?640:960;
  const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sized=(src,width)=>{const url=new URL(src,location.href);url.searchParams.set('width',width);return url.href;};
  const readyImages=new Map();
  const prepare=(src,priority='low')=>{
    if(readyImages.has(src))return readyImages.get(src);
    const img=new Image();img.decoding='async';img.fetchPriority=priority;
    const pending=new Promise(resolve=>{img.onload=()=>{img.decode().catch(()=>{}).then(()=>resolve(img));};img.onerror=()=>{readyImages.delete(src);resolve(null);};});
    readyImages.set(src,pending);img.src=src;return pending;
  };
  const warmColor=value=>{const photo=imageFor(value);if(photo)prepare(sized(photo.src,displayWidth),'high');};
  const warmColors=async()=>{
    if(navigator.connection?.saveData)return;
    const queue=Object.values(data.testGalleries).map(items=>items[0]).filter(Boolean);
    await Promise.all(Array.from({length:2},async()=>{while(queue.length)await prepare(sized(queue.shift(),displayWidth));}));
  };
  let galleryRequest=0;
  const el = (tag,cls,text) => { const e=document.createElement(tag); if(cls)e.className=cls; if(text!==undefined)e.textContent=text; return e; };
  const button = (cls,text) => {const e=el('button',cls,text);e.type='button';return e;};
  const rows = bar => Array.from(bar.querySelectorAll('.kvbp-bar-variant-selector-wrapper')).filter(w=>w.querySelector('select[data-name="Color"]'));
  const selects = row => Array.from(row.querySelectorAll('select.kvbp-bar-variant-select'));
  const pause = () => new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
  const money = cents => new Intl.NumberFormat(data.locale,{style:'currency',currency:data.currency}).format(cents/100);
  let selectedOffer=[15462524026991,15462524158063,15590718799983,15590718832751,15637816344687].includes(data.productId)?1:0;
  const offers=isClassic ? [{id:'c484766b-d134-4d6d-8c8e-2acf3ba83da7',count:1,paid:1,title:t.single},{id:'853e965d-08a1-4014-b3c5-e173bd99230c',count:4,paid:2,title:t.double},{id:'f6d7bd93-0e67-4cde-98e7-3010bbf2fd8d',count:8,paid:3,title:t.five}] : [{id:'JDVD',count:1,paid:1,title:t.single},{id:'hznN',count:4,paid:2,title:t.double},{id:'96w6',count:8,paid:3,title:t.five}];
  let nativeEngine, nativeBars, bundleRoot, syncVersion=0, syncPending=Promise.resolve(), submitReady=false;
  function choose(row,optionIndex,value) {
    const source=selects(row);source[optionIndex].value=value;
    const options=source.map(s=>s.value);
    const available=data.variants.filter(v=>v.available&&v.options[0]===options[0]);
    if(!available.some(v=>v.options[1]===options[1])&&available.length)source[1].value=available[0].options[1];
    source[1].querySelectorAll('option').forEach(o=>{o.disabled=!available.some(v=>v.options[1]===o.value);});
    const bar=row.closest('.kvbp-bar');const list=rows(bar);enhance(row,list.indexOf(row),list.length);
    showGallery(source[0].value);
    queueSync();
  }
  function showGallery(value) {
    const photo=imageFor(value),original=document.querySelector('product-info media-gallery');
    if(!photo||!original)return;
    const parent=original.parentElement;
    let gallery=parent.querySelector('.kvb-gallery');
    if(gallery?.dataset.color===value)return;
    if(!gallery){gallery=el('div','kvb-gallery');original.before(gallery);}
    gallery.dataset.color=value;
    const request=++galleryRequest;
    const items=galleryFor(value);if(!items.length)items.push(photo);
    const sources=items.map(item=>sized(item.src,displayWidth));
    const track=el('div','kvb-track'),thumbs=el('div','kvb-thumbs');
    const slides=items.map((item,i)=>{
      const img=el('img');img.width=1254;img.height=1254;img.decoding='async';img.alt=item.alt;img.draggable=false;
      if(i===0)img.src=sources[0];else{img.fetchPriority='low';if(navigator.connection?.saveData){img.loading='lazy';img.src=sources[i];}}
      track.append(img);return img;
    });
    let activeIndex=0,frame=0,gesture=null;
    const selectImage=index=>{
      const target=(index+items.length)%items.length;
      track.scrollTo({left:target*track.clientWidth,behavior:reducedMotion?'auto':'smooth'});
    };
    // Fingers scroll the track natively; the scroll position drives the active thumbnail.
    track.addEventListener('scroll',()=>{
      if(frame)return;
      frame=requestAnimationFrame(()=>{
        frame=0;if(!track.clientWidth)return;
        const index=Math.max(0,Math.min(items.length-1,Math.round(track.scrollLeft/track.clientWidth)));
        if(index===activeIndex)return;
        activeIndex=index;thumbs.querySelectorAll('button').forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));
      });
    },{passive:true});
    // A mouse cannot pan a scroller, so desktop keeps the drag-to-change gesture.
    track.onpointerdown=event=>{
      if(event.pointerType!=='mouse'||!event.isPrimary||event.button!==0){gesture=null;return;}
      gesture={id:event.pointerId,x:event.clientX,y:event.clientY};
      track.setPointerCapture(event.pointerId);
    };
    track.onpointercancel=()=>{gesture=null;};
    track.onpointerup=event=>{
      const start=gesture;gesture=null;
      if(!start||start.id!==event.pointerId)return;
      const dx=event.clientX-start.x,dy=event.clientY-start.y;
      if(Math.abs(dx)>=40&&Math.abs(dx)>Math.abs(dy)*1.5)selectImage(activeIndex+(dx<0?1:-1));
    };
    items.forEach((item,i)=>{
      const b=button('');b.setAttribute('aria-label',item.alt);b.setAttribute('aria-pressed',String(i===0));
      const img=el('img');img.src=sized(item.src,128);img.alt='';img.width=64;img.height=64;img.decoding='async';b.append(img);
      b.addEventListener('click',()=>selectImage(i));thumbs.append(b);
    });
    // On a colour change the previous photos stay up until the new first photo is ready (no grey flash).
    const mount=()=>{
      if(request!==galleryRequest)return;
      const oldTrack=gallery.querySelector('.kvb-track'),oldThumbs=gallery.querySelector('.kvb-thumbs');
      if(oldTrack)oldTrack.replaceWith(track);else gallery.prepend(track);
      if(oldThumbs)oldThumbs.replaceWith(thumbs);else gallery.append(thumbs);
    };
    const ready=prepare(sources[0],'high');
    if(gallery.querySelector('.kvb-track'))ready.then(mount);else mount();
    // The other photos wait for the first one, unless the shopper starts scrolling before it is in.
    const fill=()=>slides.forEach((img,i)=>{if(!img.getAttribute('src'))img.src=sources[i];});
    ready.then(()=>{if(request===galleryRequest)fill();});
    track.addEventListener('scroll',fill,{passive:true,once:true});
    parent.classList.add('kvb-gallery-active');
  }
  function zoom(value) {
    const image=imageFor(value);if(!image)return;
    const dialog=el('dialog','kvb-dialog');const close=button('',t.close);const img=el('img');img.src=image.src;img.alt=`KIMA — ${value}`;
    dialog.append(close,img);document.body.append(dialog);close.onclick=()=>dialog.close();dialog.addEventListener('close',()=>dialog.remove());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});dialog.showModal();
  }
  function enhance(row,index,total) {
    const source=selects(row);if(source.length!==2)return;
    let card=row.querySelector('.kvb-card');
    if(!card){
      card=el('div','kvb-card');card.dataset.collapsed='false';
      card.addEventListener('click',event=>{event.stopPropagation();});
      const heading=el('div','kvb-heading'),title=el('p','kvb-title'),toggle=button('kvb-toggle',t.close);
      toggle.setAttribute('aria-expanded','true');toggle.onclick=()=>{const collapsed=card.dataset.collapsed==='false';card.dataset.collapsed=String(collapsed);toggle.textContent=collapsed?t.edit:t.close;toggle.setAttribute('aria-expanded',String(!collapsed));};
      heading.append(title,toggle);
      const body=el('div','kvb-body'),visuals=el('div','kvb-visuals'),photo=button('kvb-photo'),img=el('img'),zoomIcon=el('span','kvb-zoom','⌕');zoomIcon.setAttribute('aria-hidden','true');photo.setAttribute('aria-label',t.zoom);photo.append(img,zoomIcon);photo.onclick=()=>zoom(selects(row)[0].value);
      const swatches=el('div','kvb-swatches');swatches.setAttribute('role','group');swatches.setAttribute('aria-label',t.color);
      Array.from(source[0].options).forEach((o,i)=>{const b=button('kvb-swatch');b.dataset.value=o.value;b.title=o.textContent;b.setAttribute('aria-label',o.textContent);const c=colorInfo(o.value);if(c?.hex)b.style.setProperty('--swatch',c.hex);if(c?.texture)b.style.setProperty('--texture',`url('/cdn/shop/files/${c.texture}')`);b.addEventListener('pointerenter',()=>warmColor(o.value),{passive:true});b.addEventListener('touchstart',()=>warmColor(o.value),{passive:true});b.addEventListener('focus',()=>warmColor(o.value));b.onclick=()=>choose(row,0,o.value);swatches.append(b);});
      const sizes=el('div','kvb-sizes');sizes.setAttribute('role','group');sizes.setAttribute('aria-label',t.size);
      const order=['S','M','L/XL','2XL','3XL'];Array.from(source[1].options).sort((a,b)=>order.indexOf(a.value)-order.indexOf(b.value)).forEach(o=>{const b=button('kvb-size',o.textContent);b.dataset.value=o.value;b.onclick=()=>choose(row,1,o.value);sizes.append(b);});
      visuals.append(photo,swatches);body.append(visuals,sizes);card.append(heading,body);row.append(card);row.classList.add('kvb-native');
    }
    const color=source[0].value,size=source[1].value,photo=imageFor(color);
    const title=card.querySelector('.kvb-title');const text=`${total>1?`#${index+1}: `:''}${color} - ${size}`;
    if(title.dataset.label!==text){title.dataset.label=text;title.textContent=text;if(index>=(offers.find(offer=>offer.count===total)?.paid??total))title.append(el('span','kvb-free',t.free));}
    const img=card.querySelector('.kvb-photo img');if(photo&&img.getAttribute('src')!==sized(photo.src,displayWidth)){img.src=sized(photo.src,displayWidth);img.alt=`KIMA — ${color}`;img.width=232;img.height=232;}
    [0,1].forEach(n=>card.querySelectorAll(n===0?'.kvb-swatch':'.kvb-size').forEach(b=>{const option=Array.from(source[n].options).find(o=>o.value===b.dataset.value);const selected=source[n].value===b.dataset.value;if(b.getAttribute('aria-pressed')!==String(selected))b.setAttribute('aria-pressed',String(selected));const disabled=!option||option.disabled||(n===1&&!data.variants.some(v=>v.available&&v.options[0]===source[0].value&&v.options[1]===b.dataset.value));if(b.disabled!==disabled)b.disabled=disabled;}));
  }
  function refreshPrices(){
    if(!bundleRoot||!nativeBars)return;
    offers.forEach((offer,index)=>{
      const native=nativeBars.querySelector(`[data-deal-bar-id="${offer.id}"]`),bar=bundleRoot.querySelectorAll('.kvbp-bar')[index];
      if(!native||!bar)return;
      const price=native.querySelector('.kaching-bundles__bar-price')?.textContent.trim();
      let full=native.querySelector('.kaching-bundles__bar-full-price')?.textContent.trim();
      if(price)bar.querySelector('.kvbp-bar-price').textContent=price;
      if(offer.count===1 && !isClassic && !full){
        const variant=selectedOffer===0?selectedVariants()[0]:data.variants.find(v=>v.available&&/^(Negro|Black|Noir|Preto|Nero|ブラック)$/i.test(v.options[0]));
        if(variant){const step=data.currency==='CLP'?100:1;const reference=variant.compare_at_price>variant.price?variant.compare_at_price:Math.round(variant.price*2995/2595/step)*step;full=money(reference);}
      }
      const crossed=bar.querySelector('.kvbp-bar-full-price');if(crossed){crossed.textContent=full||'';crossed.hidden=!full;}
      const subtitle=native.querySelector('.kaching-bundles__bar-subtitle')?.textContent.trim();
      bar.querySelector('.kvbp-bar-subtitle').textContent=offer.count===1?t.single_subtitle:(subtitle||'');
    });
  }
  function selectedVariants(){
    const bar=bundleRoot.querySelectorAll('.kvbp-bar')[selectedOffer];
    return rows(bar).map(row=>{const options=selects(row).map(s=>s.value);return data.variants.find(v=>v.available&&v.options.every((o,i)=>o===options[i]));});
  }
  function queueSync(){
    const version=++syncVersion;
    syncPending=syncPending.catch(()=>{}).then(async()=>{
      if(version!==syncVersion)return;
      const offer=offers[selectedOffer],variants=selectedVariants();
      if(variants.some(v=>!v))throw new Error(t.unavailable);
      nativeEngine.selectedDealBarId=offer.id;
      await pause();
      for(let i=0;i<variants.length;i++){
        for(let n=0;n<2;n++){
          if(version!==syncVersion)return;
          const nativeBar=nativeBars.querySelector(`[data-deal-bar-id="${offer.id}"]`);
          const inputs=nativeBar?.querySelectorAll('select.kaching-bundles__bar-variant-select');
          const input=inputs?.[i*2+n];
          if(!input)throw new Error(t.unavailable);
          if(input.value!==variants[i].options[n]){input.value=variants[i].options[n];input.dispatchEvent(new Event('change',{bubbles:true}));await pause();}
        }
      }
      await pause();refreshPrices();
    });
    return syncPending;
  }
  function verifyNativeItems(){
    const items=nativeEngine.items().filter(item=>{try{return !JSON.parse(item.properties?.__kaching_bundles||'{}').gift;}catch{return true;}});
    const wanted=new Map();for(const v of selectedVariants()){if(!v)throw new Error(t.unavailable);wanted.set(Number(v.id),(wanted.get(Number(v.id))||0)+1);}
    const actual=new Map();for(const item of items){actual.set(Number(item.id),(actual.get(Number(item.id))||0)+item.quantity);}
    if(wanted.size!==actual.size||[...wanted].some(([id,n])=>actual.get(id)!==n)){throw new Error(t.unavailable);}
    return items;
  }
  function setupCheckout(){
    const buttons=document.querySelector('product-info .product-form__buttons');if(!buttons)return;
    const error=el('p','kvb-checkout-error');error.setAttribute('role','alert');error.hidden=true;buttons.after(error);
    const gate=async event=>{
      const path=event.composedPath();const target=path.find(n=>n?.matches?.('button, a, shop-pay-wallet-button, shopify-accelerated-checkout'));
      if(submitReady||!target||!buttons.contains(target))return;
      if(!target.matches('.product-form__submit')){
        try{verifyNativeItems();error.hidden=true;}
        catch(e){event.preventDefault();event.stopImmediatePropagation();error.textContent=e.message||t.unavailable;error.hidden=false;}
        return;
      }
      event.preventDefault();event.stopImmediatePropagation();
      if(buttons.getAttribute('aria-busy')==='true')return;
      buttons.setAttribute('aria-busy','true');error.hidden=true;
      try{await queueSync();const items=verifyNativeItems();submitReady=true;nativeEngine.dispatchEvent(new CustomEvent('add-to-cart-requested',{detail:{items},bubbles:true}));}
      catch(e){error.textContent=e.message||t.unavailable;error.hidden=false;}
      finally{submitReady=false;buttons.removeAttribute('aria-busy');}
    };
    document.addEventListener('click',gate,true);
  }
  function mount() {
    const native=document.querySelector('product-info .kaching-bundles__bars');nativeEngine=document.querySelector('product-info kaching-bundles-block');if(!native||typeof nativeEngine?.items!=='function'||!nativeEngine.dealBlock||document.getElementById('kima-bundle-prototype'))return false;
    const marketBars=Array.from(native.querySelectorAll('.kaching-bundles__bar[data-deal-bar-id]'));
    if(marketBars.length!==offers.length)return false;
    offers.forEach((offer,index)=>{offer.id=marketBars[index].dataset.dealBarId;});
    nativeBars=native;
    const root=el('div','kima-vb');root.id='kima-bundle-prototype';bundleRoot=root;
    const unique=n=>Array.from(new Set(data.variants.map(v=>v.options[n])));
    offers.forEach((offer,offerIndex)=>{
      const bar=el('div','kvbp-bar'+(offerIndex===selectedOffer?' kvbp-bar--selected':''));
      const container=el('div','kvbp-bar-container');container.style.position='relative';
      if(offerIndex===1){const badge=el('div','kvbp-bar-most-popular');badge.append(el('div','kvbp-bar-most-popular__content',t.bestseller));container.append(badge);}
      const header=button('kvbp-bar-main');header.setAttribute('aria-expanded',String(offerIndex===selectedOffer));
      const radio=el('span','kvbp-bar-radio');radio.setAttribute('aria-hidden','true');
      const content=el('div','kvbp-bar-content'),left=el('div','kvbp-bar-content-left'),price=el('div','kvbp-bar-pricing');
      left.append(el('div','kvbp-bar-title',offer.title),el('div','kvbp-bar-subtitle',offer.count===1?t.single_subtitle:''));
      price.append(el('s','kvbp-bar-full-price',''));price.append(el('div','kvbp-bar-price','…'));content.append(left,price);header.append(radio,content);
      const variants=el('div','kvbp-bar-variants');
      for(let i=0;i<offer.count;i++){
        const row=el('div','kvbp-bar-variant-selector-wrapper'),hidden=el('div','kvbp-bar-variant');
        [0,1].forEach(n=>{const select=el('select','kvbp-bar-variant-select');select.dataset.name=n===0?'Color':'Talla';select.setAttribute('aria-label',n===0?t.color:t.size);unique(n).forEach(v=>{const o=el('option','',v);o.value=v;select.append(o);});const isDefaultColor=v=>['negro','black','noir','preto','nero',normalize('ブラック')].includes(normalize(v.options[0]));const initial=data.variants.find(v=>v.available&&isDefaultColor(v)&&v.options[1]==='M')||data.variants.find(v=>v.available&&isDefaultColor(v))||data.variants.find(v=>v.available);select.value=initial.options[n];hidden.append(select);});
        row.append(hidden);variants.append(row);
      }
      container.append(header,variants);bar.append(container);root.append(bar);
      header.onclick=()=>{selectedOffer=offerIndex;root.querySelectorAll('.kvbp-bar').forEach((b,j)=>{b.classList.toggle('kvbp-bar--selected',j===offerIndex);b.querySelector('.kvbp-bar-main').setAttribute('aria-expanded',String(j===offerIndex));});showGallery(selects(rows(bar)[0])[0].value);queueSync();};
      rows(bar).forEach((r,i)=>enhance(r,i,offer.count));
    });
    native.before(root);native.hidden=true;native.style.display='none';document.querySelector('product-info').classList.add('kvb-prototype-active');
    document.querySelectorAll('product-info *').forEach(e=>{if(e.children.length===0&&e.textContent.trim()==='COMPRA 2 Y LLÉVATE 2 GRATIS')e.textContent=t.double;});
    showGallery(selects(rows(root.querySelectorAll('.kvbp-bar')[selectedOffer])[0])[0].value);
    new MutationObserver(refreshPrices).observe(native,{childList:true,subtree:true,characterData:true});
    refreshPrices();queueSync();setupCheckout();
    setTimeout(warmColors,250);
    return true;
  }
  if(!mount()){const observer=new MutationObserver(()=>{if(mount())observer.disconnect();});observer.observe(document.body,{childList:true,subtree:true});setTimeout(()=>observer.disconnect(),30000);}

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
